import React from 'react';
import AtlaskitButton, { Appearance } from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { ButtonProps } from '../index';

interface DefaultButtonProps extends ButtonProps {
  clickHandler: (e: React.MouseEvent<HTMLElement>) => void;
  testId: string;
}

export const DefaultButton: React.FC<DefaultButtonProps> = ({
  label,
  type,
  clickHandler,
  iconBefore,
  iconAfter,
  appearance,
  testId,
  href,
  target,
  fullWidth = false,
  disabled = false,
  isLoading = false,
  selected = false,
}) => {
  return (
    <AtlaskitButton
      aria-label={label.replaceAll('-', ' ')}
      type={type}
      onClick={clickHandler}
      iconBefore={iconBefore}
      iconAfter={iconAfter}
      appearance={appearance as Appearance}
      testId={testId}
      href={href}
      target={target}
      shouldFitContainer={fullWidth}
      isDisabled={disabled || isLoading}
      isSelected={selected}
      css={[
        isLoading &&
          !label &&
          css({
            padding: '21px 49px',
            alignItems: 'center',
          }),
        fullWidth &&
          css({
            width: '100%',
            justifyContent: 'center',
          }),
      ]}
    >
      <span css={[isLoading && label && css({ marginRight: token('space.100') })]}>{label}</span>
      {isLoading && <Spinner testId="spinner" size="small" />}
    </AtlaskitButton>
  );
};
